module.exports = __webpack_public_path__ + "img/drink.31ca699d.svg";